import React from 'react'
import { useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Card, CardBody, CardHeader, Row, Col, Alert } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ListEmployeeApi } from "../../../../services/Api";
import { genericGet, genericPost } from "../../../../services/Api";
import { EbmsLoading, log } from "../../../../services/Utils";
 
import Select from 'react-select';

import { SUCCESS_RESULT,ENDPOINTS } from "../../../../Constants";
import { 
  FaTimes, 
  FaEdit, 
  FaFileExport, 
  FaUser, 
  FaPlusCircle, 
  FaTimesCircle, 
  FaSave, 
  FaAd, 
  FaHistory,
  FaBuilding,
  FaCode,
  FaTag,
  FaDollarSign,
  FaWallet,
  FaCheckCircle,
  FaExclamationTriangle,
  FaList
} from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
 
const CreateBudgetCodes = () => {
  const toggle = () => setshowModal(!showModal);
  const [isLoading, setIsLoading] = useState(false);
 
  
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
const [showModal, setshowModal] = useState(false)
 const [selected_staff, setselected_staff] = useState(null)
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [project_codes, setproject_codes] = useState([])
  const [selected_project, setselected_project] = useState(null)
  const [selected_line, setselected_line] = useState(null)
const [contracted_salary, setcontracted_salary] = useState(0)
const [amount, setamount] = useState(0)
const [percentage, setpercentage] = useState(0)
const [form_data, setForm_data] = useState({})
const [previous_allocs, setprevious_allocs] = useState([])
const [lines, setlines] = useState([])
const [tags, setTags] = useState([])
 

  useEffect(() => {
    fetch_data();
    loadProjects();
    loadTags();
    return () => {};
  }, []);
  
  const updateData = e => {
    setForm_data({
        ...form_data,
        [e.target.name]: e.target.value
    })
}



const removeLine=(budget_line)=>{
  let _lines=lines;
  _lines=_lines.filter(function( obj ) {
    return obj.budget_line !== budget_line;
})
  setlines([]);
  setlines(_lines);

}

const get_total_balance=()=>{

  let total=0;
  lines.forEach((l)=>{
    total=Number(total)+Number(l.balance);
  })
  return total;

}
const get_total_amount=()=>{

  let total=0;
  lines.forEach((l)=>{
    total=Number(total)+Number(l.budget);
  })
  return total;

}
const add_budget=(e)=>{
  e.preventDefault();
 
  
  // validations
// if(form_data?.project_id==null ){
//   cogoToast.error("Please Select Budget line " , {
//     hideAfter: 5,
// });
//   return;
// }

let line_exist=lines.filter(function( obj ) {
  return obj.code == form_data?.code;
});

if(line_exist?.length  > 0 ){
  cogoToast.error("Budget line already added  " , {
    hideAfter: 5,
});
  return;
}
 


// if(Number(get_total_percentage())+Number(form_data?.percentage) > 100){
//   cogoToast.error("Percentage could not Exceed 100%  " , {
//     hideAfter: 5,
// });
// return;
// }




// END OF VALIDATIONS
let _lines=lines;

  setlines([]);
  _lines.push(form_data);
  setTimeout(() => {
 
    setlines(_lines);
    document.getElementById("form").reset();
    setForm_data(null)
  }, 100);
 
 

}

const  delete_allocation=(id)=>{
  setIsLoading(true);
  genericPost(ENDPOINTS.DELETE_ALLOCATION, {
    "allocation_id": id
   })
    .then((res) => {
      console.log(res)
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          cogoToast.success("Allocation Deleted Successfully", {});
          get_previous_allocations(selected_staff?.id);
          
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}
const saveBudgetCodes=()=>{
 
let data={
  project_id:selected_project?.value,
  budget_lines:lines

}
console.clear();
console.log("DataToSend",data)
setIsLoading(true);
genericPost(ENDPOINTS.CREATE_BUDGET_CODES, data)
  .then((res) => {

    setIsLoading(false);
    if (res.status == 200) {
      if (res.data.status == SUCCESS_RESULT) {
        let data = res.data.data;
        // clean-up
        setlines([])
        get_previous_allocations(selected_staff?.id);
        console.log("Create-allocation Result",data)
        cogoToast.success(res.data.message, {});


   
      } else {
        cogoToast.error(res.data.message, {});
      }

    }

  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });


}

const get_previous_allocations=(id)=>{
  setIsLoading(true);
  genericPost(ENDPOINTS.STAFF_ALLOCATIONS, {
    "staff_id": id
   })
    .then((res) => {
      setIsLoading(false);
      if (res.status == 200) {
      
        if (res.data.status == SUCCESS_RESULT) {
          let responseData = res.data.data;
          setprevious_allocs(responseData)
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
    });
}
  const loadProjects = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.GET_PROJECT_CODES, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            log("setproject_codes",responseData);
            // log("RIGHTS: ", responseData);
            setproject_codes(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const loadTags = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.LIST_TAGS, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
    console.clear();
    console.log(responseData);
            setTags(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  


  const fetch_data = () => {
    setProcessing(true);

    ListEmployeeApi()
      .then((res) => {
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);


  return (
    <div className="container-fluid" style={{ padding: "20px" }}>
      {/* Header Section */}
      <Card className="shadow-sm mb-4">
        <CardHeader className="bg-primary text-white">
          <Row className="align-items-center">
            <Col>
              <h3 className="mb-0">
                <FaCode className="me-2" />
                Budget Codes Management
              </h3>
              <small className="text-light">Create and manage budget codes for projects</small>
            </Col>
          </Row>
        </CardHeader>
      </Card>

      <Row>
        {/* Form Section */}
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <CardHeader className="bg-light">
              <h5 className="mb-0">
                <FaPlusCircle className="me-2 text-success" />
                Add New Budget Code
              </h5>
            </CardHeader>
            <CardBody>
              <form onSubmit={add_budget} id="form">
                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaBuilding className="me-1" />
                    Project
                  </Label>
                  <Select
                    styles={{width:"100%"}}
                    value={selected_project}
                    onChange={(e) => {
                      setselected_project({
                        value: e.value,
                        label: e.label
                      })
                    }}
                    options={project_codes.map((p) => ({value: p.id, label: p.project_name}))}
                    placeholder="Select a project..."
                  />
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaCode className="me-1" />
                    Budget Name
                  </Label>
                  <input 
                    className='form-control' 
                    name="name"     
                    onChange={(e) => {
                      try {
                        setForm_data({
                          ...form_data,
                          ["name"]: e.target.value
                        })
                      } catch(e) { 
                      }
                    }}
                    placeholder="Enter budget name..."
                    required
                  /> 
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaCode className="me-1" />
                    Budget Code
                  </Label>
                  <input 
                    className='form-control' 
                    name="code"     
                    onChange={(e) => {
                      try {
                        setForm_data({
                          ...form_data,
                          ["code"]: e.target.value
                        })
                      } catch(e) { 
                      }
                    }}
                    placeholder="Enter budget code..."
                    required
                  /> 
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaTag className="me-1" />
                    Tag
                  </Label>
                  <select 
                    className='form-control' 
                    name="tag" 
                    id="tag"
                    onChange={(e) => {
                      var e = document.getElementById("tag");
                      var name = e.options[e.selectedIndex].text;
                      var value = e.options[e.selectedIndex].value;

                      try {
                        setForm_data({
                          ...form_data,
                          ["tag"]: value,
                          ["tag_name"]: name
                        })
                      } catch(e) { 
                      }
                    }}
                    required
                  > 
                    <option value="">Select Tag...</option>
                    {tags.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.tag_name} - {t.tag_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaDollarSign className="me-1" />
                    Total Budget
                  </Label>
                  <input 
                    className='form-control' 
                    name="budget"     
                    type="number"
                    step="0.01"
                    min="0"
                    onChange={(e) => {
                      try {
                        setForm_data({
                          ...form_data,
                          ["budget"]: e.target.value
                        })
                      } catch(e) { 
                      }
                    }}
                    placeholder="Enter total budget..."
                    required
                  /> 
                </div>

                <div className="mb-3">
                  <Label className="fw-bold">
                    <FaWallet className="me-1" />
                    Balance
                  </Label>
                  <input 
                    className='form-control'      
                    type="number"
                    step="0.01"
                    min="0"
                    onChange={(e) => {
                      try {
                        setForm_data({
                          ...form_data,
                          ["balance"]: e.target.value
                        })
                      } catch(e) { 
                      }
                    }}
                    placeholder="Enter balance..."
                    required
                  /> 
                </div>

                <Button type='submit' className='btn btn-primary w-100'>
                  <FaPlusCircle className="me-1" />
                  Add Budget Code
                </Button> 
              </form>
            </CardBody>
          </Card>
        </Col>

        {/* Budget Codes List */}
        <Col md={8}>
          <Card className="shadow-sm">
            <CardHeader className="bg-light">
              <h5 className="mb-0">
                <FaList className="me-2 text-info" />
                Added Budget Codes
              </h5>
            </CardHeader>
            <CardBody>
              {lines.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th><FaCode className="me-1" />Budget Line</th>
                        <th><FaTag className="me-1" />Tag</th>
                        <th><FaDollarSign className="me-1" />Budget</th>
                        <th><FaWallet className="me-1" />Balance</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lines?.map((l, index) => (
                        <tr key={index}>
                          <td className="fw-bold">{l.code} - {l.name}</td>      
                          <td>
                            <span className="badge bg-secondary">{l.tag_name}</span>
                          </td>
                          <td>
                            <span className="text-success fw-bold">
                              ${Number(l.budget).toLocaleString()}
                            </span>
                          </td>
                          <td>
                            <span className="text-info fw-bold">
                              ${Number(l.balance).toLocaleString()}
                            </span>
                          </td>
                          <td>
                            <Button
                              color="outline-danger"
                              size="sm"
                              onClick={(e) => removeLine(l.budget_line)}
                            >
                              <FaTimesCircle />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="table-light">
                      <tr className="fw-bold">
                        <td colSpan={2}>Total</td>
                        <td className="text-success">${Number(get_total_amount()).toLocaleString()}</td>
                        <td className="text-info">${Number(get_total_balance()).toLocaleString()}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              ) : (
                <Alert color="info" className="text-center">
                  <FaExclamationTriangle className="me-2" />
                  No budget codes added yet. Please add budget codes using the form.
                </Alert>
              )}

              <div className="mt-3 text-end">
                <Button 
                  className='btn btn-success btn-lg' 
                  disabled={lines.length === 0}  
                  onClick={() => saveBudgetCodes()}
                >
                  <FaSave className="me-2" />
                  Save All Budget Codes
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default CreateBudgetCodes